import { render } from "./RecycleBuilding.vue?vue&type=template&id=20f9d62c"
import script from "./RecycleBuilding.vue?vue&type=script&lang=js"
export * from "./RecycleBuilding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__